/*
 * @Description: 
 * @Author: ywj
 * @Date: 2025-03-27 09:37:49
 * @LastEditTime: 2025-04-08 11:23:13
 * @LastEditors: ywj@originqc.com
 */
import React from 'react';
import { setDefaultAddr } from '@/api/personal-center';
import './index.scss';
import { Address, getAddressList, setDeleteModalState, setEditModalState } from '@/redux/address';
import { dispatch } from '@/redux/store';
import { message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

interface Props extends Address {
  onClick?: (id: number) => void;
  addressId?: number;
  province?: string;
  city?: string;
  region?: string;
}

const Cell: React.FC<Props> = (props) => {
  const setDefault = (props: Address) => {
    setDefaultAddr(String(props.id)).then((res: any) => {
      if (res.success) {
        dispatch(getAddressList());
        message.success('操作成功');
        return;
      }
      message.error(res.message);
    });
  };

  const onEdit = (props: Address) => {
    dispatch(
      setEditModalState({
        open: true,
        isAdd: false,
        title: '编辑收货地址',
        id: String(props.id),
      })
    );
  };

  const onDelete = (props: Address) => {
    dispatch(
      setDeleteModalState({
        open: true,
        id: String(props.id),
      })
    );
  };

  return (
    <div className="cell-wrap">
      <div className={`cell ${props.addressId === props.id && 'active'}`} onClick={() => props.onClick && props.onClick(props.id)}>
        <div className="line1">
          <div className="line1-left">
            <span title={props.name}>{props.name}</span>
            <span>{props.tel}</span>
            {props.defaultStatus === 1 && <span>默认地址</span>}
          </div>
          <div className="line1-right">
            {!props.defaultStatus && <span onClick={() => setDefault(props)}>设为默认地址</span>}
            <span onClick={() => onEdit(props)}>修改</span>
            <span onClick={() => onDelete(props)}>删除</span>
          </div>
        </div>
        <div className="line2">{ props.province}&nbsp;{ props.city}&nbsp;{ props.region}&nbsp;{props.detailAddress}</div>
      </div>
    </div>
  );
};

export default Cell;

export const EmptyAddressCell: React.FC = () => {
  return (
    <div className="empty-cell-wrap" onClick={() => dispatch(setEditModalState({ isAdd: true, open: true, title: '新增收货地址', id: '' }))}>
      <div className="cell empty-cell">
        <PlusOutlined />
        <span style={{ marginLeft: '2px' }}>新增收货地址</span>
      </div>
    </div>
  );
};
